/* eslint-disable indent */
/* eslint-disable prettier/prettier */
/* eslint-disable react-native/no-inline-styles */
import React, { useState, useEffect, useRef } from 'react';
import { View, Text, Animated, ActivityIndicator } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';

import { scale, notchTop, height } from '@components/frame';
import { isWeb } from '@helpers';

import TouchableElement from '@components/common/touchableElement';
import AnimatedHeader from '@components/common/AnimatedHeader';
import Line from '@components/common/line';

import Svg from '@styles/icons/svg';
import ColorWrapper from '@styles/colors';
import { getBoxShadowStyle } from '@styles/shadow';
import { font } from '@styles/fonts';

import { getTools, close, create } from '@reducers/tools';

import AddTool from '@components/tool/components/addTool';
import { ToolsDetailsScreenName } from '@v2/pages/tools/details/navigation/config';
import { ToolsDetailsScreen } from '@v2/pages/tools/details/common/enums/toolsDetails.enum';
import { Perspective } from '@v2/pages/common/enums';
import { useHandleMainDetailsScreenNavigation } from '@v2/pages/common/hooks/useHandleMainDetailsScreenNavigation';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

const Tools = ({ C, getTools, close, tools = [], loaded }) => {
  const [alowLoadMore, setLoadMore] = useState(true);
  const [showAddTool, setShowAddTool] = useState(false);
  const toogleShowAddTool = () => {
    setShowAddTool(!showAddTool);
  };
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const scrollRef = useRef(null);

  const { navigateToMainDetailsScreen } = useHandleMainDetailsScreenNavigation();

  useEffect(() => {
    close();
    getTools();
    return () => {
      close();
    };
  }, []);

  const HeaderAction = () => (
    <View style={{ position: 'absolute', right: scale(10), top: scale(isWeb ? 9 : 24), zIndex: 100000 }}>
      <TouchableElement
        {...{
          onPress: toogleShowAddTool,
        }}
      >
        {({ boxStyle }) => (
          <View style={[boxStyle, {}]}>
            <Svg icon="plus" width={scale(16)} height={scale(16)} color={'Link/Light/Special'} />
          </View>
        )}
      </TouchableElement>
    </View>
  );

  const isCloseToBottom = ({ layoutMeasurement, contentOffset, contentSize }) => {
    return layoutMeasurement.height + contentOffset.y >= contentSize.height - 1500;
  };

  const scrollListener = ({ nativeEvent }) => {
    if (alowLoadMore && isCloseToBottom(nativeEvent)) {
      setLoadMore(false);
      setTimeout(() => {
        setLoadMore(true);
      }, 1000);
    }
  };

  return [
    <View
      key="ToolList"
      style={{
        width: '100%',
        paddingBottom: scale(130),
        paddingTop: notchTop,
        backgroundColor: C('Background/Light/Detail'),
        height: '100%',
      }}
    >
      <AnimatedHeader
        {...{
          actions: [{ component: HeaderAction, key: 'HeaderAction' }],
          backText: i18n.t('Settings'),
          text: i18n.t('Tools'),
          C,
          animated: false,
          back: true,
          backgroundColor: 'Background/Light/Detail',
          borderBottomWidth: 0,
        }}
      />
      <Animated.ScrollView
        scrollEventThrottle={16}
        ref={scrollRef}
        onScroll={Animated.event([{ nativeEvent: { contentOffset: { y: fadeAnim } } }], {
          useNativeDriver: true,
          listener: scrollListener,
        })}
        style={{
          backgroundColor: C('Background / Light / Detail'),
          width: '100%',
          minHeight: height,
          paddingTop: scale(isWeb ? 76 : 83),
        }}
      >
        <View style={{ width: '100%', paddingLeft: scale(15), paddingRight: scale(15) }}>
          <View style={[getBoxShadowStyle({type: 'Field', C}),{ marginTop: scale(5), width: '100%', borderRadius: scale(SCREEN_BORDER_RADIUS) }]}>
            {tools.map((tool, index) => (
              <Line
                {...{
                  item: {
                    name: tool.toolName,
                    bottom: tool.toolDescription,
                    value: tool.toolStickoutMM,
                    onClick: () => {
                      return navigateToMainDetailsScreen({
                        mainScreen: ToolsDetailsScreenName,
                        subScreen: ToolsDetailsScreen.TOOLS,
                        params: {
                          perspective: Perspective.TOOLS,
                          toolId: tool.toolId,
                        },
                      });
                    },
                  },
                  index,
                  array: tools,
                  bigSize: true,
                  C,
                  topBorder: index !== 0,
                  roundTop: index === 0,
                  roundBottom: index === tools.length - 1,
                }}
                key={tool.toolId}
              />
            ))}
          </View>
          {loaded && !tools.length && (
            <Text
              style={[
                {
                  color: C('Label/Light/Tertiary'),
                  width: '100%',
                  textAlign: 'center',
                },
                font.Body,
              ]}
            >
              {i18n.t('No Tools')}
            </Text>
          )}
        </View>
        {!loaded || !alowLoadMore ? (
          <View style={{ width: '100%', marginTop: scale(20), justifyContent: 'center', height: 50 }}>
            <ActivityIndicator size="small" color="#777777" />
          </View>
        ) : null}
        <View style={{ width: '100%', minHeight: 200 }} />
      </Animated.ScrollView>
    </View>,
    <AddTool
      key="AddTool"
      {...{
        showAddTool,
        toogleShowAddTool,
      }}
    />,
  ];
};

export default connect(({ tools: { tools, loaded } }) => ({ tools, loaded }), {
  getTools,
  close,
  create,
})(ColorWrapper(Tools));
